<operation-table>
  <ng-container slot="header">
    <div class="operation-table-with-progress-header">
      <span class="operation-table-with-progress-header-title">
        {{(progress?.totals.processed_files + ' / ' + progress?.totals.discovered_files + ' ' + (progressTitle | translate))}}
      </span>
      <fw-progress-bar class="operation-table-with-progress-header-progress" mode="determinate" [value]="progressValue"
        [color]="progressBarColor"></fw-progress-bar>
      <div class="operation-table-with-progress-header-subtitle-container">
        <span class="operation-table-with-progress-header-subtitle">{{(progress?.totals.processed_bytes | storageUnit)
      +' / ' + (progress?.totals.discovered_bytes | storageUnit) + ' '  +  progressSubtitle }}</span>
        <span *ngIf="progressSummary"
          class="operation-table-with-progress-header-status {{progressBarStatusColor || progressSummaryColor}}">
          {{progressBarStatusText || (progressSummary | translate | interpolate: (progress.totals.failed_files || progress.totals.skipped_files))}}</span>
      </div>
    </div>
  </ng-container>
  <ng-container slot="body">
    <ng-content></ng-content>
  </ng-container>
</operation-table>
